import LocationInterface from '@solvhealth/types/interfaces/Location';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { locationError, receiveLocation, setActiveLocation } from '~/actions/location';
import { setOrigin } from '~/actions/newBooking';
import { setPastBooking } from '~/actions/pastBookings';
import { BookingStatus } from '~/constants';
import { apiGetDispatchable, apiGetJson } from '~/core/dapi';
import {
  getSolvAndUclMergedLocationUrl,
  LOCATION_FIELDS_NO_APPOINTMENT_DATES,
} from '~/core/dapi/location';
import { getPublicBookingByIdUrl } from '~/core/dapi/waitList';
import { opaqueLocation } from '~/core/location/opaque';
import { hasBeenTransferred } from '~/core/util/booking';
import { getCurrentlySelectedLocationFromState, isTelemedLocation } from '~/core/util/location';
import { EMPTY_OBJECT, isEmptyObject } from '~/core/util/object';
import { useSolvSelector } from '~/reducers';
import logger from '../../../core/logger';

export default (bookingId: string) => {
  const dispatch = useDispatch();
  const location = useSelector((state) => state.location) as LocationInterface;
  const pastBookings = useSolvSelector((state) => state.pastBookings);

  useEffect(() => {
    apiGetJson(getPublicBookingByIdUrl(bookingId))
      .then((response: any) => {
        dispatch(setPastBooking(response.data));
        const locationId = response.data.location_id;
        if (!locationId) {
          dispatch(receiveLocation(opaqueLocation));
        } else {
          dispatch(
            apiGetDispatchable(
              getSolvAndUclMergedLocationUrl(
                locationId,
                true,
                LOCATION_FIELDS_NO_APPOINTMENT_DATES
              ),
              setActiveLocation,
              locationError(locationId)
            )
          );
        }
      })
      .catch((e: any) => logger.error(e));
  }, [bookingId, dispatch]);

  const booking = useMemo(() => {
    const booking = pastBookings?.[bookingId] ?? EMPTY_OBJECT;

    // fake booking status of confirmed for special "telemed queue" behavior
    if (!isEmptyObject(booking) && isTelemedLocation(location) && hasBeenTransferred(booking)) {
      return { ...booking, status: BookingStatus.CONFIRMED };
    }

    return booking;
  }, [pastBookings, bookingId, location]);

  useEffect(() => {
    dispatch(setOrigin(booking?.origin));
  }, [dispatch, booking?.origin]);

  return { booking, location };
};
